import { useGoogleLogin } from "@react-oauth/google"
import { notification } from "antd"
import React from "react"
import { useHistory } from "react-router"

import { useOauth } from "../../hooks/useOauth"
import { NetworkUnauthorizedError, OauthAction } from "../../interfaces"
import { t } from "../../lib/i18n"
import LoginOauthButton from "../Login/LoginOauthButton"
import SignupOauthButton from "../Signup/SignupOauthButton"

type GoogleOauthButtonProps = {
  oauthAction: OauthAction
  isVisible: boolean
}

const GoogleOauthButton = (props: GoogleOauthButtonProps): JSX.Element => {
  const { onGoogle } = useOauth(props.oauthAction)
  const history = useHistory()

  // **Hook はすべて早期 return より前に呼ぶ（#425）。**
  // 以前はここに `if (!props.isVisible) return <></>` があり、`useGoogleLogin` が
  // そのあとだった。`isVisible` はログイン画面で動的に変わる
  // （`Login.tsx:107` の `showGoogleButton && !isVisibleProfile`。しかも
  // `useLoginButtonVisibility` は `showGoogleButton` を false で初期化して
  // mount 後の effect で true にするので、**/login を開くたびに false → true が起きる**）。
  // いま落ちていないのは、早期 return より前の `useHistory` が useContext で
  // **Hook のスロットを消費しない**という偶然のおかげでしかない。
  // 上に `useState` を 1 つ足した瞬間に
  // `Rendered more hooks than during the previous render.` になる（実測済み）。
  const onClick = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      try {
        await onGoogle(codeResponse.access_token)
      } catch (error) {
        if (error instanceof NetworkUnauthorizedError) {
          if (error.message === "401 Unauthorized") {
            const nonce = new URLSearchParams(window.location.search).get(
              "nonce",
            )
            const nonceParam = nonce ? `?nonce=${nonce}` : ""
            history.push(`/signup?error=401${nonceParam}`)
          } else {
            notification.error({
              message: t("account_already_registered"),
            })
          }
          return
        }
        notification.error({
          message: t("unknown_error"),
        })
      }
    },
    onError: () => {
      notification.error({
        message: t("unknown_error"),
      })
    },
    onNonOAuthError: () => {
      notification.error({
        message: t("unknown_error"),
      })
    },
  })

  if (!props.isVisible) {
    return <></>
  }

  if (props.oauthAction === "signup") {
    return (
      <SignupOauthButton
        isVisible={props.isVisible}
        oauthType="google"
        onClick={onClick}
        className="cta-signup"
      />
    )
  }

  return (
    <LoginOauthButton
      isVisible={props.isVisible}
      oauthType="google"
      onClick={onClick}
    />
  )
}

export default GoogleOauthButton
